import posthog from 'posthog-js'

export function postHogIdentifyUser(phone: string) {
    posthog.identify(phone, {
        phone_number: phone,
    })
}

export { posthog }
